export default __webpack_public_path__ + "static/media/user.6d36937a.svg";